import React, { Fragment, useRef } from "react";
import { Card, CardBody, CardHeader, Col, Container, Table, Row, Label, Modal, ModalHeader, ModalBody, ModalFooter, Collapse } from 'reactstrap';

import { api } from "../utils/index";
import CardLoader from "./CardLoader";
import MyDateRenderer from "./MyDateRenderer";
import HtmlToPdfButton from "./HtmlToPdfButton";
import logoLight from "../assets/images/logo192.png";

const FormReadyToIssueSASO = (props) => {
    const divPrintRef = useRef(null);

    const [readyToIssueFormCollapsed, setReadyToIssueFormCollapsed] = React.useState(true);
    const [generatingPdf, setGeneratingPdf] = React.useState(false);
    const [formVersion, setFormVersion] = React.useState(props.formTemplate ? props.formTemplate.version : 1);
    
    React.useEffect(() => {
        if(props.formTemplate) {
            setFormVersion(props.formTemplate.version)
        }
    }, [props.formTemplate]);

    const getVersionName = () => {
        if(props.formTemplate) {
            return props.formTemplate.versionName;
        }

        return "";
    }

    const isTableEditable = () => {
        if(generatingPdf || (props.fboState && props.fboState.canEditFormReadyToIssue)) {
            return true;
        }

        return false;
    }
    
    return(
        <Card className="card-success mb-3">
            <CardHeader className="border-0 d-flex align-items-center">
                <CardLoader loading={props.loading || generatingPdf} />
                <h5 className="card-title mb-0 flex-grow-1 cursor-pointer" onClick={() => setReadyToIssueFormCollapsed(!readyToIssueFormCollapsed)}>
                    {readyToIssueFormCollapsed && <i className="ri-add-box-line align-bottom text-primary"></i>}
                    {!readyToIssueFormCollapsed && <i className="ri-checkbox-indeterminate-line align-bottom text-primary"></i>}
                    Ready To Issue Form ({readyToIssueFormCollapsed ? "Expand" : "Collapse"})
                </h5>
            </CardHeader>
            <CardBody className="border border-dashed border-end-0 border-start-0">
                <Collapse isOpen={!readyToIssueFormCollapsed} className="collapse">
                    <Row className="gy-2" style={{backgroundColor:"white"}}>
                        <Col>
                            <HtmlToPdfButton
                                setGeneratingPdf={setGeneratingPdf}
                                fileName={props.fboState.ticket.requestNumber + " Ready To Issue Form.pdf"}
                                divPrintRef={divPrintRef}
                            />
                        </Col>
                        <div className={`col-md-12 col-xxl-12 ${generatingPdf ? "table-form-print" : ""}`} ref={divPrintRef}>
                            {generatingPdf &&
                            <Fragment>
                                <table className="table-form">
                                    <tbody>
                                        <tr>
                                            <td style={{textAlign:"left", border: "none", backgroundColor: "white", verticalAlign: "bottom"}}><h5><b>Ready To Issue Form - SASO</b></h5></td>
                                            <td style={{textAlign:"right", border: "none", backgroundColor: "white"}}><img src={logoLight} alt="" height="100" /></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table className={`table-form ${isTableEditable() ? "" : "table-form-readonly"}`}>
                                    <tbody>
                                        <tr>
                                            <td style={{width:"25%"}}>Request Number over SABER</td>
                                            <td>{(props.fboState && props.fboState.ticket && props.fboState.ticket.sasoRequestNumber) || ""}&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Project Number over COC</td>
                                            <td>{(props.fboState && props.fboState.ticket && props.fboState.ticket.requestNumber) || ""}&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Commercial Registration (CR) No</td>
                                            <td>{(props.customer && props.customer.length > 0 && props.customer[0].commercialRegistrationNumber) || ""}&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Client Name</td>
                                            <td>{(props.customer && props.customer.length > 0 && props.customer[0].organizationName) || ""}&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Manufacturer Name</td>
                                            <td>{(props.manufacturer && props.manufacturer.length > 0 && props.manufacturer[0].organizationName) || ""}&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Technical Regulation</td>
                                            <td>{(props.fboState && props.fboState.ticket && props.fboState.ticket.technicalRegulation) || ""}&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>Date of Request</td>
                                            <td>
                                                <MyDateRenderer value={(props.fboState && props.fboState.ticket && props.fboState.ticket.dateAdded) || ""} format={"dd.mm.yyyy"} />&nbsp;
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Fragment>
                            }
                            <table className={`table-form ${isTableEditable() ? "" : "table-form-readonly"}`}>
                                <thead>
                                    <tr>
                                        <td colSpan={7} style={{textAlign:"center", border: "none", backgroundColor: "white"}}><h5><b>Ready To Issue</b></h5></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="header">
                                        <td>#</td>
                                        <td>Points to be checked<sup>1</sup></td>
                                        <td colSpan={3}>Data Processing User</td>
                                        <td>Type 1a</td>
                                        <td>Type 3</td>
                                    </tr>
                                    <tr>
                                        <td className="index-col">1</td>
                                        <td>Has the Supplier Declaration of Conformity been uploaded to the SABER Platform?</td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("readyToIssueForm", "SupplierDeclarationUploaded") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("readyToIssueForm", "SupplierDeclarationUploaded", "Yes")} onChange={e => props.setFieldValue("readyToIssueForm", "SupplierDeclarationUploaded", "Yes", e.target.checked)} /> Yes
                                        </td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("readyToIssueForm", "SupplierDeclarationUploaded") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("readyToIssueForm", "SupplierDeclarationUploaded", "No")} onChange={e => props.setFieldValue("readyToIssueForm", "SupplierDeclarationUploaded", "No", e.target.checked)} /> No
                                        </td>
                                        <td className="check-col">&nbsp;</td>
                                        <td className="check-col">X</td>
                                        <td className="check-col">X</td>
                                    </tr>
                                    <tr>
                                        <td className="index-col">2</td>
                                        <td>Has the Test Report been uploaded to the SABER Platform?</td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("readyToIssueForm", "TestReportUploaded") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("readyToIssueForm", "TestReportUploaded", "Yes")} onChange={e => props.setFieldValue("readyToIssueForm", "TestReportUploaded", "Yes", e.target.checked)} /> Yes
                                        </td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("readyToIssueForm", "TestReportUploaded") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("readyToIssueForm", "TestReportUploaded", "No")} onChange={e => props.setFieldValue("readyToIssueForm", "TestReportUploaded", "No", e.target.checked)} /> No
                                        </td>
                                        <td className="check-col">&nbsp;</td>
                                        <td className="check-col">X</td>
                                        <td className="check-col">X</td>
                                    </tr>
                                    <tr>
                                        <td className="index-col">3</td>
                                        <td>Has the Risk Assessment Form been uploaded to the SABER Platform?</td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("readyToIssueForm", "RiskAssessmentUploaded") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("readyToIssueForm", "RiskAssessmentUploaded", "Yes")} onChange={e => props.setFieldValue("readyToIssueForm", "RiskAssessmentUploaded", "Yes", e.target.checked)} /> Yes
                                        </td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("readyToIssueForm", "RiskAssessmentUploaded") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("readyToIssueForm", "RiskAssessmentUploaded", "No")} onChange={e => props.setFieldValue("readyToIssueForm", "RiskAssessmentUploaded", "No", e.target.checked)} /> No
                                        </td>
                                        <td className="check-col">&nbsp;</td>
                                        <td className="check-col">X</td>
                                        <td className="check-col">X</td>
                                    </tr>
                                    <tr>
                                        <td className="index-col">4</td>
                                        <td>Have all required photos been uploaded to the SABER Platform?</td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("readyToIssueForm", "PhotosUploaded") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("readyToIssueForm", "PhotosUploaded", "Yes")} onChange={e => props.setFieldValue("readyToIssueForm", "PhotosUploaded", "Yes", e.target.checked)} /> Yes
                                        </td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("readyToIssueForm", "PhotosUploaded") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("readyToIssueForm", "PhotosUploaded", "No")} onChange={e => props.setFieldValue("readyToIssueForm", "PhotosUploaded", "No", e.target.checked)} /> No
                                        </td>
                                        <td className="check-col">&nbsp;</td>
                                        <td className="check-col">X</td>
                                        <td className="check-col">X</td>
                                    </tr>
                                    <tr>
                                        <td className="index-col">5</td>
                                        <td>Has the Factory Audit Report been uploaded to the SABER Platform?</td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("readyToIssueForm", "FactoryAuditReportUploaded") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("readyToIssueForm", "FactoryAuditReportUploaded", "Yes")} onChange={e => props.setFieldValue("readyToIssueForm", "FactoryAuditReportUploaded", "Yes", e.target.checked)} /> Yes
                                        </td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("readyToIssueForm", "FactoryAuditReportUploaded") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("readyToIssueForm", "FactoryAuditReportUploaded", "No")} onChange={e => props.setFieldValue("readyToIssueForm", "FactoryAuditReportUploaded", "No", e.target.checked)} /> No
                                        </td>
                                        <td className="check-col">
                                            <input type="radio" className={`${props.isValidFieldValue("readyToIssueForm", "FactoryAuditReportUploaded") ? "" : "checkbox-is-invalid"}`} checked={props.getFieldValue("readyToIssueForm", "FactoryAuditReportUploaded", "N/A")} onChange={e => props.setFieldValue("readyToIssueForm", "FactoryAuditReportUploaded", "N/A", e.target.checked)} /> N/A
                                        </td>
                                        <td className="check-col">-</td>
                                        <td className="check-col">X</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className={`table-form ${isTableEditable() ? "" : "table-form-readonly"}`}>
                                <thead>
                                    <tr className="header">
                                        <td colSpan={2}>Review of Conflict of Interest</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan={2}>I undertake to inform the Technical Manager or Group Team Leader in the event of any of the following matters related to the specified client.</td>
                                    </tr>
                                    <tr>
                                        <td className="check-col">
                                            <input type="checkbox" checked={props.getFieldValue("readyToIssueForm", "HaveRelationship", "Yes")} onChange={e => props.setFieldValue("readyToIssueForm", "HaveRelationship", "Yes", e.target.checked)} />
                                        </td>
                                        <td>In the management of the client, I have close family members and person/people with whom I have a personal or business relationship that can affect objectivity.</td>
                                    </tr>
                                    <tr>
                                        <td className="check-col">
                                            <input type="checkbox" checked={props.getFieldValue("readyToIssueForm", "PerformedAudit", "Yes")} onChange={e => props.setFieldValue("readyToIssueForm", "PerformedAudit", "Yes", e.target.checked)} />
                                        </td>
                                        <td>In the last two years, I have performed internal audit and training services in the client, including quality consultancy.</td>
                                    </tr>
                                    <tr>
                                        <td className="check-col">
                                            <input type="checkbox" checked={props.getFieldValue("readyToIssueForm", "ProvidedServices", "Yes")} onChange={e => props.setFieldValue("readyToIssueForm", "ProvidedServices", "Yes", e.target.checked)} />
                                        </td>
                                        <td>I provided services in the supply, design, service provider developer of the client's products, operation, and development of product-related processes.</td>
                                    </tr>
                                    <tr>
                                        <td className="check-col">
                                            <input type="checkbox" checked={props.getFieldValue("readyToIssueForm", "PreventImpartiality", "Yes")} onChange={e => props.setFieldValue("readyToIssueForm", "PreventImpartiality", "Yes", e.target.checked)} />
                                        </td>
                                        <td>There are illegal financial and other conditions that prevent my impartiality.</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className={`table-form ${isTableEditable() ? "" : "table-form-readonly"}`}>
                                <tbody>
                                    <tr>
                                        <td style={{width:"30%"}}>Name</td>
                                        <td style={{width:"40%"}}>Signature</td>
                                        <td style={{width:"30%"}}>Date</td>
                                    </tr>
                                    <tr>
                                        <td>{(props.fboState && props.fboState.readyToIssueForm && props.fboState.readyToIssueForm.signedByName) || ""}&nbsp;</td>
                                        <td>
                                            {props.fboState && props.fboState.readyToIssueForm && props.fboState.readyToIssueForm.signedBySignature &&
                                                <div>
                                                    <img className="img-fluid" style={{maxWidth:"100%", maxHeight: "100px", cursor: "pointer"}} src={`${api}Document/DownloadDocumentByName?fileName=${props.fboState.readyToIssueForm.signedBySignature}`} alt="Not Found" />
                                                </div>
                                            }&nbsp;
                                        </td>
                                        <td>
                                            <MyDateRenderer value={(props.fboState && props.fboState.readyToIssueForm && props.fboState.readyToIssueForm.ticketForm && props.fboState.readyToIssueForm.ticketForm.dateSigned) || ""} format={"dd.mm.yyyy"} />&nbsp;
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="table-form table-form-alt">
                                <tbody>
                                    <tr>
                                        <td style={{width:"30%", paddingTop:50}}>------------------------------------------</td>
                                        <td style={{width:"30%"}}>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>
                                            <sup>1</sup> If there is any missing information in <b>“Points to be Checked”</b> section, please connect with the Decision Maker
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="table-form table-form-alt">
                                <tbody>
                                    <tr>
                                        <td colSpan={3}><hr/></td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"25%", textAlign:"left"}}>Status: Approved</td>
                                        <td style={{width:"50%", textAlign:"center"}}>{getVersionName()}</td>
                                        <td style={{width:"25%", textAlign:"center"}}>Classification: Intrenal</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Row>
                </Collapse>
            </CardBody>
        </Card>
    );
};

export default FormReadyToIssueSASO;